import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Stop } from '../../../models/route-replay-response.model';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-stops-timeline',
  templateUrl: './stops-timeline.component.html',
  styleUrl: './stops-timeline.component.scss'
})
export class StopsTimelineComponent implements OnInit, OnChanges {
  @Input() stops: Stop[] = [];
  
  isExpanded: boolean = false;
  displayedStops: Stop[] = [];
  hiddenStopsCount: number = 0;

  ngOnInit(): void {
    this.updateDisplayedStops();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stops']) {
      this.updateDisplayedStops();
    }
  }

  updateDisplayedStops(): void {
    if (this.stops.length <= 4) {
      // Show all stops if 4 or less
      this.displayedStops = this.stops;
      this.hiddenStopsCount = 0;
    } else {
      if (this.isExpanded) {
        // Show all stops when expanded
        this.displayedStops = this.stops;
        this.hiddenStopsCount = 0;
      } else {
        // Show first and last stop, hide middle ones
        this.displayedStops = [
          this.stops[0],
          this.stops[this.stops.length - 1]
        ];
        this.hiddenStopsCount = this.stops.length - 2;
      }
    }
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
    this.updateDisplayedStops();
  }

  getPlannedTime(timestamp: number | null): string {
    if (!timestamp) return 'N/A';
    return dayjs(timestamp).format('HH:mm');
  }

  getETA(actualTime: number, plannedTime: number | null): { text: string; color: string; isDelayed: boolean } | null {
    // If either time is null, don't show anything
    if (!actualTime || !plannedTime) {
      return null;
    }

    const diffMinutes = Math.round((actualTime - plannedTime) / (1000 * 60));
    const actualTimeFormatted = dayjs(actualTime).format('HH:mm');

    if (diffMinutes <= 0) {
      // On time or early - show actual time in green
      return { 
        text: actualTimeFormatted, 
        color: '#4CAF50', 
        isDelayed: false 
      };
    } else {
      // Delayed - show "time (+X mins)" in red
      return { 
        text: `${actualTimeFormatted} (+${diffMinutes} min${diffMinutes > 1 ? 's' : ''})`, 
        color: '#F44336', 
        isDelayed: true 
      };
    }
  }

  shouldShowExpandButton(): boolean {
    return this.stops.length > 4;
  }

  getStopNumber(index: number): number {
    if (this.isExpanded || this.stops.length <= 4) {
      return index + 1;
    }
    // When collapsed, show actual stop numbers
    if (index === 0) return 1;
    return this.stops.length;
  }
}
